import React from "react";
import Card from "../../shared/Card";
import { Row, Col } from "react-bootstrap";

function ManifestDetail(props) {
  return (
    <Card
      cardType="default"
      cardHeader="Manifest Details"
      headerColor="#046B99"
      headerTextColor="white"
      cardBody={
        <div>
          <Row>
            <Col md="6" xs="6">
              Manifest Number:
            </Col>
            <Col md="6" xs="6">
              {props.Manifest.MANIFEST_ID}
            </Col>
          </Row>
          <Row>
            <Col md="6" xs="6">
              Generator:
            </Col>
            <Col md="6" xs="6">
              <a
                href={`/facility/${props.Manifest.GEN_EPA_ID}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <div>{props.Manifest.GEN_NAME}</div>
                <div>{props.Manifest.GEN_EPA_ID}</div>
              </a>
            </Col>
          </Row>
          <Row>
            <Col md="6" xs="6">
              Ship Date:
            </Col>
            <Col md="6" xs="6">
              {props.Manifest.SHIPMENT_DATE}
            </Col>
          </Row>
          <Row>
            <Col md="6" xs="6">
              Receipt Date:
            </Col>
            <Col md="6" xs="6">
              {props.Manifest.RECEIPT_DATE}
            </Col>
          </Row>
          <Row>
            <Col md="6" xs="6">
              TSDF:
            </Col>
            <Col md="6" xs="6">
              <a
                href={`/facility/${props.Manifest.TSDF_EPA_ID}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {props.Manifest.TSDF_EPA_ID}
              </a>
            </Col>
          </Row>
          <Row>
            <Col md="6" xs="6">
              Alt-TSDF:
            </Col>
            <Col md="6" xs="6">
              {" "}
              <a href={`/facility/${props.Manifest.TSDF_ALT_ID}`} target="_blank">
                {props.Manifest.TSDF_ALT_ID}
              </a>
            </Col>
          </Row>
          <Row>
            <Col md="6" xs="6">
              Version:
            </Col>
            <Col md="6" xs="6">
              {props.Manifest.VERSION_ID}
            </Col>
          </Row>
        </div>
      }
      cardColor="white"
    />
  );
}

export default ManifestDetail;
